export function formatDate(dateStr) {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}

export function formatMonthYear(monthYear) {
  if (!monthYear) return '';
  const [year, month] = monthYear.split('-');
  return `${month}/${year}`;
}

export function formatDateTime(timestamp) {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleString('en-GB');
}
